import { apiClient } from "./apiClient";

export const queensApi = {
  create: (payload) => apiClient.post("/queens", payload).then((r) => r.data),
  addLineage: (payload) => apiClient.post("/queens/lineage", payload).then((r) => r.data),
  logPerformance: (payload) => apiClient.post("/queens/performance", payload).then((r) => r.data),

  // Requeening (#259). Not `create` with a hive_id: that overwrote the
  // pointer and left the previous queen orphaned and active.
  replace: (payload) => apiClient.post("/queens/replace", payload).then((r) => r.data),
};
